import { useRepositoryMutation } from '@mews-commander/data-access';
import { lt, showSuccessAlert } from '@mews/framework';
import { AddProductFormCardFormValues } from './types';

export const useAddProductOrderMutation = ({ reservationIds }: { reservationIds: string[] }) => {
    return useRepositoryMutation('reservations', 'addProductOrder', {
        transformParams: ({ productId, count, consumedUTC }: AddProductFormCardFormValues) => {
            return {
                productOrders: reservationIds.map((reservationId) => ({
                    reservationId,
                    productId,
                    count,
                    consumedUtc: consumedUTC,
                })),
            };
        },
        onSuccess: () => {
            showSuccessAlert({ description: lt('AddProductOrderSuccessMessage') });
        },
    });
};
